export default __webpack_public_path__ + "static/media/person-line_blue.7801f586.svg";